import useSWR from 'swr'
import { useAppContext } from '~/src/context/AppProvider'
import fetcher from '~/src/lib/fetcher'

const useGetUrlFromHash = () => {
  const { hash } = useAppContext()
  const { data, isValidating, isLoading } = useSWR<{
    url: string
  }>(hash ? `/api/url?hash=${hash}` : null, fetcher, {
    revalidateOnFocus: false,
  })

  return {
    url: data?.url,
    isValidating,
    isLoading,
  }
}

export default useGetUrlFromHash
